<template>
  <div class="apply">
    <div class="content">
      <div class="ay_title">立即体验穗盈生鲜供应链系统</div>
      <div class="ay_remark">我们提供食材配送管理系统，不提供货源和客源</div>
      <ul>
        <li>
          <img src="@/assets/img/index/icon/contact_1name.svg" />
          <el-input v-model="ruleForm.name" placeholder="姓名" @change="changeName"></el-input>
          <div v-if="nameFlag" class="error">{{textName}}</div>
        </li>
        <li>
          <img src="@/assets/img/index/icon/contact_2phone.svg" />
          <el-input v-model="ruleForm.tel" placeholder="手机号码" @change="changeTel"></el-input>
          <div v-if="telFlag" class="error">{{textTel}}</div>
        </li>
        <li>
          <img src="@/assets/img/index/icon/contact_3enterprise.svg" />
          <el-input v-model="ruleForm.company" placeholder="企业名称"></el-input>
        </li>
        <el-button type="primary" class="sub_btn" @click="applySubmit">提交</el-button>
      </ul>
      <div class="ay_tel">
        <img src="@/assets/img/index/icon/contact_4telephone.svg" />
        <span class="tel">咨询电话：</span>
        <span class="telNo">林经理：15920366002</span>
      </div>
    </div>
    <!-- 试用成功弹框 -->
    <el-dialog :visible.sync="successVisible" class="su_dialog">
      <img src="@/assets/img/index/icon/submitted_successfully.svg" class="logo" />
      <div class="title">提交成功</div>
      <div class="des">您的申请已提交成功！ </div>
      <div class="des">我们会安排专人联系您，请留意信息哦~ </div>
      <div class="des">感谢您对智慧农业的支持！</div>
      <el-button type="primary" @click="successVisible = false">我知道了</el-button>
      <div class="hot_tel">如有疑问，请拨打咨询热线：<a href="tel:+15920366002" class="tel">林经理：15920366002</a></div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ApplyIndex",
  data () {
    return {
      baseUrl: this.$baseUrl,
      ruleForm: {
        name: '',
        tel: '',
        company: '',
        type: '0-20'
      },
      nameFlag: false,
      telFlag: false,
      textTel: '请输入手机号',
      textName: '请输入姓名',
      // 申请成功弹框
      successVisible: false,
    }
  },
  created () {},
  methods: {
    // 申请-input-姓名
    changeName (e) {
      if (e) {
        if (e.length < 2 || e.length > 5) {
          this.textName = '长度在 2 到 5 个字符'
          this.nameFlag = true
        } else {
          this.nameFlag = false
        }
      } else {
        this.nameFlag = true
      }
    },
    // 申请-input-手机号码
    changeTel (e) {
      if (e) {
        if (!(/^1[3456789]\d{9}$/.test(e))) {
          this.textTel = '请输入正确手机号'
          this.telFlag = true
        } else {
          this.telFlag = false
        }
      }
    },
    // 试用提交
    applySubmit () {
      let form = this.ruleForm
      let that = this
      if (!form.name) {
        this.nameFlag = true
        if (!form.tel) {
          this.telFlag = true
        }
        return
      } else if (!form.tel) {
        this.telFlag = true
        if (!form.name) {
          this.nameFlag = true
        }
        return
      } else {
        let _data = {
          name: that.ruleForm.name,
          phoneNum: that.ruleForm.tel,
          companyName: that.ruleForm.company,
          systemType: 1,
        }
        const url = that.baseUrl + "/public/applySave"
        axios.get(url, { params: _data }).then(res=>{
          console.log('aa')
          console.log(res)
          if (res.data.statusCode === 300) {
            that.$message.error(res.data.message);
          }
          if (res.data.statusCode === 200) {
            that.applyVisible = false
            that.successVisible = true
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/pc/components/applyIndex.vue